

























import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';

interface Tabbar {
  title: string;
  path: string;
  id: string | number;
}

@Component
export default class BottomTabbar extends Vue {
  @Prop({ default: Array }) tabbars!: Tabbar[];
  @Model('activeTabChange', { type: Number, default: 0 })
  readonly activeTab!: number;

  onTabClick(item: Tabbar, index: number) {
    this.$emit('activeTabChange', index);
    if (index !== 1 && index !== 2 && index !== 3) {
      if (item.path === this.$route.path) {
        return location.reload();
      }
      this.$router.replace(item.path);
    }
  }
}
